export const fonts = {
    poppins: "font-family: 'Poppins', sans-serif;",
    arial: "font-family: Arial, sans-serif;",
};
//# sourceMappingURL=fonts.js.map